var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray2 py-2 px-1 px-md-2",
      class: !_vm.keyPoints[1] ? "max-width-bloc" : "",
      attrs: { id: "key-points" },
    },
    [
      _c("div", { staticClass: "row text-center" }, [
        _c(
          "div",
          {
            staticClass: "col-12 pe-2",
            class: _vm.keyPoints[1] ? "col-md-6 key-point-block-border" : "",
          },
          [
            _c("div", {
              staticClass: "h4 mb-auto",
              domProps: { innerHTML: _vm._s(_vm.keyPoints[0].title) },
            }),
            _vm._v(" "),
            _c("strong", {
              domProps: { innerHTML: _vm._s(_vm.keyPoints[0].paragraph) },
            }),
            _vm._v(" "),
            _vm.keyPoints[1]
              ? _c("hr", {
                  staticClass: "d-md-none my-2 separator separator--gray3",
                })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.keyPoints[1]
          ? _c("div", { staticClass: "col-12 col-md-6 ps-2" }, [
              _c("div", {
                staticClass: "h4 mb-auto",
                domProps: { innerHTML: _vm._s(_vm.keyPoints[1].title) },
              }),
              _vm._v(" "),
              _c("strong", {
                domProps: { innerHTML: _vm._s(_vm.keyPoints[1].paragraph) },
              }),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }